import Add from "@mui/icons-material/Add";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Check from "@mui/icons-material/Check";
import Close from "@mui/icons-material/Close";
import Delete from "@mui/icons-material/Delete";
import Download from "@mui/icons-material/Download";
import Edit from "@mui/icons-material/Edit";
import FilterAlt from "@mui/icons-material/FilterAlt";
import History from "@mui/icons-material/History";
import Inventory2Outlined from "@mui/icons-material/Inventory2Outlined";
import MoreVert from "@mui/icons-material/MoreVert";
import Refresh from "@mui/icons-material/Refresh";
import Save from "@mui/icons-material/Save";
import Search from "@mui/icons-material/Search";
import Send from "@mui/icons-material/Send";
import Sync from "@mui/icons-material/Sync";
import ThumbDownAltOutlined from "@mui/icons-material/ThumbDownAltOutlined";
import ThumbUpAltOutlined from "@mui/icons-material/ThumbUpAltOutlined";
import Upload from "@mui/icons-material/Upload";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export enum AsyncButtonStartIconValues {
  AddIconValue,
  EditValue,
  DeleteIconValue,
  SaveIconValue,
  RefreshIconValue,
  SearchIconValue,
  CloseIconValue,
  CheckIconValue,
  UploadValue,
  DownloadValue,
  FilterAltValue,
  SyncValue,
  HistoryValue,
  VisibilityIconValue,
  VisibilityOffIconValue,
  MoreValue,
  SendIconValue,
  ApproveValue,
  RejectValue,
  ArchiveValue,
  ArrowBackValue,
}

export function renderAsyncButtonIcon(iconValue: AsyncButtonStartIconValues | null | undefined): React.JSX.Element | null {
  switch (iconValue) {
    case AsyncButtonStartIconValues.AddIconValue:
      return <Add />;
    case AsyncButtonStartIconValues.EditValue:
      return <Edit />;
    case AsyncButtonStartIconValues.DeleteIconValue:
      return <Delete />;
    case AsyncButtonStartIconValues.SaveIconValue:
      return <Save />;
    case AsyncButtonStartIconValues.RefreshIconValue:
      return <Refresh />;
    case AsyncButtonStartIconValues.SearchIconValue:
      return <Search />;
    case AsyncButtonStartIconValues.CloseIconValue:
      return <Close />;
    case AsyncButtonStartIconValues.CheckIconValue:
      return <Check />;
    case AsyncButtonStartIconValues.UploadValue:
      return <Upload />;
    case AsyncButtonStartIconValues.DownloadValue:
      return <Download />;
    case AsyncButtonStartIconValues.FilterAltValue:
      return <FilterAlt />;
    case AsyncButtonStartIconValues.SyncValue:
      return <Sync />;
    case AsyncButtonStartIconValues.HistoryValue:
      return <History />;
    case AsyncButtonStartIconValues.VisibilityIconValue:
      return <Visibility />;
    case AsyncButtonStartIconValues.VisibilityOffIconValue:
      return <VisibilityOff />;
    case AsyncButtonStartIconValues.MoreValue:
      return <MoreVert />;
    case AsyncButtonStartIconValues.SendIconValue:
      return <Send />;
    case AsyncButtonStartIconValues.ApproveValue:
      return <ThumbUpAltOutlined />;
    case AsyncButtonStartIconValues.RejectValue:
      return <ThumbDownAltOutlined />;
    case AsyncButtonStartIconValues.ArchiveValue:
      return <Inventory2Outlined />;
    case AsyncButtonStartIconValues.ArrowBackValue:
      return <ArrowBack />;
    default:
      return null;
  }
}
